export default {
  cdnId: 'property-block-image-gallery',
  width: 1000,
  aspect: '4/3',
  quality: 75,
  useDefaultImage: true
};
